import React from 'react';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';
import CalendlyPopup from '../CalendlyPopup';
import { useCalendlyAndVideo } from '../../hooks/useCalendlyAndVideo';

const TechnologyHero = () => {
  const { isCalendlyOpen, openCalendly, closeCalendly } = useCalendlyAndVideo();

  return (
    <section className="relative pt-24 sm:pt-32 pb-16 sm:pb-24 px-4 sm:px-6 overflow-hidden">
      <div className="relative z-20 max-w-7xl mx-auto">
        <div className="max-w-5xl mx-auto text-center">
          <h1 className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-4 sm:mb-6 leading-tight text-white">
            Your Platform Scales Faster Than Your People Can
          </h1>

          <p className="text-lg sm:text-xl md:text-2xl text-gray-300 font-semibold mb-4 sm:mb-6">
            Enablement for Technology Platforms & Cloud Marketplaces
          </p>

          <p className="text-base sm:text-lg text-cyan-400 font-semibold mb-4 sm:mb-6">
            Powered by Traain AI
          </p>

          <p className="text-base sm:text-lg md:text-xl text-gray-300 mb-8 sm:mb-12 max-w-4xl mx-auto leading-relaxed">
            Technology platforms and cloud marketplaces grow through ecosystems—partners, resellers, vendors, and internal teams.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button
              size="lg"
              onClick={openCalendly}
              className="h-12 sm:h-14 bg-cyan-500 text-black hover:bg-cyan-400 rounded-lg px-6 sm:px-8 text-base sm:text-lg font-semibold transition-all duration-200 hover:scale-105 hover:shadow-lg hover:shadow-cyan-500/50"
            >
              See Traain for Technology Platforms
              <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 ml-2" />
            </Button>
          </div>
        </div>
      </div>
      
      <CalendlyPopup isOpen={isCalendlyOpen} onClose={closeCalendly} />
    </section>
  );
};

export default TechnologyHero;
